import React from 'react';
import { useTranslation } from 'react-i18next';

import ChevronDownIcon from '../../resources/assets/icons/ChevronDownIcon';
import ChevronUpIcon from '../../resources/assets/icons/ChevronUpIcon';
import MenuManager from '../../services/api/MenuManager';
import { ModifierEntryType } from '../../services/exports/Constants';
import { useHelpers } from '../../providers/HelpersProvider';
import { Card, Switch, Table } from 'antd';

export default function ModifierGroupCard({ data, isCollapsed, toggle, onModifierChange }) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Cards:ModifierGroupCard' });

  const { formatCurrency } = useHelpers();

  const toggleModifierGroupVisible = () => {
    MenuManager.toggleModifierGroupVisible(data).then(() => onModifierChange());
  };

  const toggleModifierAvailable = (modifier) => {
    let promise;

    if (modifier.type === ModifierEntryType.Product) {
      promise = MenuManager.updateProduct(modifier.id, { is_available: !modifier?.is_available });
    } else {
      promise = MenuManager.toggleModifierAvailable(modifier);
    }

    promise.then(() => onModifierChange());
  };

  return (
    <Card classNames={{ body: '!p-none' }}>
      <div className="p-md">
        <div className="flex items-center justify-between px-2">
          <div className="flex justify-center items-center py-md">
            <h4 className="text-black my-0 mr-4">{data?.name}</h4>
            <div className="text-white bg-primary justify-center items-center rounded-sm px-2 my-auto">
              {data.modifiers.length}
            </div>
          </div>
          <div className="py-md text-black cursor-pointer flex justify-center" onClick={toggle}>
            <p className="mx-md my-auto">{isCollapsed ? t('labels.open') : t('labels.collapse')}</p>
            {isCollapsed ? <ChevronDownIcon color="#000000" /> : <ChevronUpIcon color="#000000" />}
          </div>
        </div>
        {!data.is_master && (
          <div className="flex items-center gap-xs">
            <Switch
              id={`modifier-group-${data?.id}-is-visible`}
              className="disabled-danger"
              size="xl"
              checked={data.is_visible}
              onChange={toggleModifierGroupVisible}
            />
            <label htmlFor={`modifier-group-${data?.id}-is-visible`}>
              {data.is_visible ? t('labels.visible') : t('labels.hidden')}
            </label>
          </div>
        )}
      </div>
      {!isCollapsed && (
        <div className="w-full overflow-x-auto">
          <Table
            className="bg-white"
            pagination={false}
            dataSource={data.modifiers}
            rowKey={(item) => `modifier-${data?.id}-${item.id}`}
            columns={[
              {
                key: 'is_available',
                title: t('list.is_available'),
                render: (item) => (
                  <div className="flex flex-col">
                    <Switch
                      id={`modifier-group-${data.id}-modifier-${item?.id}-is-available`}
                      checked={item.is_available}
                      onChange={() => toggleModifierAvailable(item)}
                      className="w-fit"
                    />
                    <label htmlFor={`modifier-group-${data.id}-modifier-${item?.id}-is-available`} className="mt-xs">
                      {item.is_available ? t('labels.in_stock') : t('labels.out_of_stock')}
                    </label>
                  </div>
                ),
              },
              {
                key: 'name',
                title: t('list.name'),
                dataIndex: 'name',
              },
              {
                key: 'price',
                title: t('list.price'),
                render: (item) => formatCurrency(item.price),
              },
            ]}
          />
        </div>
      )}
    </Card>
  );
}
